import { createRoute, Outlet } from "@tanstack/react-router";

import { rootRoute } from "./__root.js";

/**
 * Family-host tenant scope — `/t/$tenantSlug/…`.
 *
 * On `devices.portal…` / `gop.portal…` the leaf Insights tenant lives
 * in this path segment; `portalFetch` sends it as `X-Portal-Tenant`.
 */
export const tenantScopeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/t/$tenantSlug",
  component: TenantScopeLayout,
});

function TenantScopeLayout() {
  return <Outlet />;
}
